let lenisInstance = null;

export function setLenisInstance(lenis) {
  lenisInstance = lenis;
}

export function getHeaderOffsetPx() {
  if (typeof window === 'undefined') {
    return -80;
  }

  const styles = getComputedStyle(document.documentElement);
  const navHeight = styles.getPropertyValue('--nav-height').trim() || '4.25rem';
  const rootPx = parseFloat(styles.fontSize) || 16;
  const value = parseFloat(navHeight);
  const px = navHeight.endsWith('rem') ? value * rootPx : value;

  return -px;
}

export function clearUrlHash() {
  const { pathname, search } = window.location;
  window.history.replaceState(null, '', `${pathname}${search}`);
}

export function scrollToSection(sectionId, { offset } = {}) {
  const target = document.getElementById(sectionId);
  if (!target) {
    return;
  }

  const scrollOffset = offset ?? getHeaderOffsetPx();

  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset: scrollOffset });
  } else {
    const top = target.getBoundingClientRect().top + window.scrollY + scrollOffset;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  clearUrlHash();
}

export function scrollToTop({ immediate = false } = {}) {
  if (lenisInstance) {
    lenisInstance.scrollTo(0, immediate ? { immediate: true } : undefined);
  } else {
    window.scrollTo({ top: 0, behavior: immediate ? 'auto' : 'smooth' });
  }

  clearUrlHash();
}

export function handleInitialHashScroll() {
  const hash = window.location.hash;
  if (!hash || hash.length <= 1) {
    return;
  }

  const sectionId = hash.slice(1);
  const target = document.getElementById(sectionId);

  if (target) {
    window.requestAnimationFrame(() => {
      const scrollOffset = getHeaderOffsetPx();

      if (lenisInstance) {
        lenisInstance.scrollTo(target, { offset: scrollOffset });
      } else {
        const top = target.getBoundingClientRect().top + window.scrollY + scrollOffset;
        window.scrollTo({ top, behavior: 'auto' });
      }
      clearUrlHash();
    });
  } else {
    clearUrlHash();
  }
}
